import { useCallback, useState } from 'react';

export default function useDropOpened<R>(
  initialState?: R | undefined
): [R | undefined, (reference: R, value: boolean) => void] {
  const [opened, setOpened] = useState<R | undefined>(initialState);
  const toggleOpened = useCallback(
    (reference: R, value: boolean) => {
      if (value) {
        setOpened(reference);
      } else if (opened === reference) {
        setOpened(undefined);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [opened]
  );
  return [opened, toggleOpened];
}
